var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H39C52.2548 0 63 10.7452 63 24V39C63 52.2548 52.2548 63 39 63H24C10.7452 63 0 52.2548 0 39V24Z",
    fill: "#F8B01F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4312 46.55C23.9354 46.9583 23.4177 46.9729 22.8781 46.5938C22.3385 46.2146 22.1708 45.7187 22.375 45.1062L25.2625 35.7L17.825 30.3625C17.3 29.9833 17.1323 29.4948 17.3219 28.8969C17.5115 28.299 17.9271 28 18.5688 28H27.8L30.7312 18.2C30.8187 17.8792 30.9865 17.6385 31.2344 17.4781C31.4823 17.3177 31.7375 17.2375 32 17.2375C32.2625 17.2375 32.5177 17.3177 32.7656 17.4781C33.0135 17.6385 33.1813 17.8792 33.2688 18.2L36.2 28H45.4312C46.0729 28 46.4885 28.299 46.6781 28.8969C46.8677 29.4948 46.7 29.9833 46.175 30.3625L38.7375 35.7L41.625 45.1062C41.8292 45.7187 41.6615 46.2146 41.1219 46.5938C40.5823 46.9729 40.0646 46.9583 39.5688 46.55L32 40.775L24.4312 46.55Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.18cedd8992f417b075783ab589f4a014.svg";
export { ForwardRef as ReactComponent };